const NotFound = () => {
  return <h1>Madan Gopal</h1>;
};

export default NotFound;
